/**
 * @desc 会员中心: 创建角色
 */
import { MemberRoleForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateMemberRoleParameter = MemberRoleForm

const method = 'POST'
const url = '/auth/member/role'

export const createMemberRoleApi = (
  data?: CreateMemberRoleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createMemberRoleApi.method = method
createMemberRoleApi.url = url
